import styled from '@emotion/styled'
import {
  Container,
  CriticalIcon as PayPalCriticalIcon,
  Row,
} from '@paypalcorp/pp-react'

export const ErrorContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 375px !important;
  padding: 4rem 0rem;
`

export const CriticalIcon = styled(PayPalCriticalIcon)`
  width: 160px;
  height: 160px;
`

export const TextContainer = styled(Row)`
  display: flex;
  padding: 16px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`

export const HeadingRow = styled(Row)`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  text-align: center;
`

export const TextRow = styled(Row)`
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  text-align: center;
`
